<template>
  <div class="container">
    <div v-if="list.length > 0" class="scroll">
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="min-height: calc(100vh - 13.4vw); overflow: auto"
        pulling-text=" "
        loosing-text=" "
      > -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="到底啦~"
          @load="onLoad"
        >
          <!-- <van-card
            v-for="sku in list"
            :title="sku.packageName"
            :num="sku.goodsQuantity"
            :price="formatPrice(sku.retailPrice)"
            :thumb="sku.packagePic"
            :key="sku.id"
            @click="onClick(sku.id)"
          >
          </van-card> -->
          <div
            v-for="sku in list"
            :key="sku.id"
            @click="onClick(sku.id)"
            class="card_list flex-row"
          >
            <div class="card_img">
              <img :src="sku.packagePic" alt="" />
            </div>
            <div class="card_right">
              <div class="card_title">{{ sku.packageName }}</div>
              <div class="flex-between">
                <div class="card_desc">{{ sku.packageDesc }}</div>
                <div class="card_num">x {{ sku.goodsQuantity }}</div>
              </div>

              <div class="card_price">￥{{ formatPrice(sku.retailPrice) }}</div>
            </div>
          </div>
        </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <div v-else class="index-empty">
      <div class="imageEmptySearch">
        <img src="../../../assets/images/search.png" alt />
      </div>
      商家很懒，没有任何商品
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Card,
  Button,
  Grid,
  GridItem,
  Image,
  Toast,
  List,
  PullRefresh,
  Loading,
  Overlay
} from "vant";
import service from "../../api/package/index";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    loading
  },
  data() {
    return {
      showEmpty: true,
      show: {
        primary: true,
        success: true
      },
      isLoading: true, //loading状态
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      finished: false,
      refreshing: false,
      firstLoading: false
    };
  },
  created() {
    this.init(this.$route.query.value);
    localStorage.removeItem("getParamsAddress");
  },
  methods: {
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    onClick(id) {
      this.$router.push({
        name: "package",
        query: {
          id: id
        }
      });
    },
    init() {
      this.getpackageList().then((packageList) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        if (packageList.items.length !== 0) {
          this.list = packageList.items;
        } else {
          this.list = [];
        }
        this.loading = false;
        if (packageList.totalCount <= 10) {
          this.finished = true;
        }
        // else {
        //     this.onLoad();
        //   }
      });
    },
    onLoad() {
      if (this.list.length > 10) {
        this.page++;
        this.getpackageList().then((packageList) => {
          this.list = this.list.concat(packageList);
          this.loading = false;
          if (packageList.totalCount <= this.list.length) {
            this.finished = true;
          }
          // else {
          //   this.onLoad();
          // }
        });
      }
    },
    // onRefresh() {
    //   // 清空列表数据
    //   this.page = 1;
    //   this.finished = false;
    //   // 重新加载数据
    //   // 将 loading 设置为 true，表示处于加载状态
    //   this.loading = true;
    //   this.list = [];
    //   this.isLoading = true;
    //   this.getpackageList().then((packageList) => {
    //     this.isLoading = false;
    //     if (packageList.items.length !== 0) {
    //       this.list = packageList.items;
    //     } else {
    //       this.list = [];
    //     }
    //     if (packageList.totalCount <= this.list.length) {
    //       this.finished = true;
    //       this.loading = false;
    //     }
    //     //
    //     this.refreshing = true;
    //     this.onLoad();
    //   });
    // },
    getpackageList() {
      return new Promise((resolve, reject) => {
        service
          .list(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    handlepackageClick(Id) {
      this.$router.push({ name: "package", query: { Id: Id } });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  // height: 100%;
  min-height: 100vh;
  // background: #fff;
}
.scroll {
  padding-bottom: 18vw;
  //
  // padding-bottom: 15vw;
}
// 准备用全局card
.van-card {
  background-color: #fff;
  height: 120px;
  padding: 17px 15px;
}
.card_list {
  height: 26vw;
  padding: 4.53333vw 4vw;
  background: #fff;
  margin-bottom: 6px;
  border-bottom: 1px solid #f7f7f7;
  .card_title {
    max-height: 8.53333vw;
    line-height: 4.26667vw;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding-top: 9px;
  }
  .card_desc {
    color: #929292;
  }
  .card_img {
    width: 85px;
    height: 85px;
    border-radius: 5px;
  }
  .card_num {
    font-size: 14px;
  }
  .card_right {
    flex: 1;
    padding: 0 3vw 1vw;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
  }
  .card_price {
    font-size: 14px;
    color: rgb(238, 10, 36);
  }
}
</style>